export const SIMULTANEOUS_ACCESS_CONTENT = {
  GLOBAL_LIMIT_EXCEEDED: {
    title: "Limite de usuários atingido",
    description:
      "No momento, o número máximo de usuários simultâneos foi atingido. Aguarde alguns minutos até que uma sessão seja liberada e tente novamente.",
  },
  DEVICE_LIMIT_EXCEEDED: {
    title: "Limite de dispositivos conectados",
    description:
      "Identificamos que este mesmo usuário está sendo utilizado em diversos dispositivos ao mesmo tempo. Por segurança, o acesso foi restrito. Tente novamente em alguns minutos.",
  },
};
